/**
 * Display helpers for Shipment Details. MySQL 0/1 often arrives as "0"/"1";
 * "0" is truthy in JavaScript and must not be treated as Yes.
 */

const YES_VALUES = new Set([true, 1, '1', 'true', 'True', 'yes', 'Yes']);
const NO_VALUES = new Set([false, 0, '0', 'false', 'False', 'no', 'No']);

export function flagYesNo(value) {
  if (YES_VALUES.has(value)) return 'Yes';
  if (NO_VALUES.has(value)) return 'No';
  return null;
}

export function isYesFlag(value) {
  return YES_VALUES.has(value);
}

const BILL_TO_LABELS = {
  inpayer: 'Prepaid',
  prepaid: 'Prepaid',
  collect: 'Collect',
  third_party: 'Third Party',
};
const SERVICE_LABELS = {
  standard: 'Standard',
  expedite: 'Expedite',
};
const EXPEDITE_LABELS = {
  '1_day': '1 Day',
  '2_day': '2 Day',
};

function displayLabel(value, labels) {
  if (value == null) return null;
  const raw = String(value).trim();
  if (!raw) return null;
  return labels[raw] || labels[raw.toLowerCase()] || raw;
}

export function formatBillTo(value) {
  return displayLabel(value, BILL_TO_LABELS);
}

export function formatService(value) {
  return displayLabel(value, SERVICE_LABELS);
}

export function formatExpedite(value) {
  return displayLabel(value, EXPEDITE_LABELS);
}

export function formatLineItemWeight(item) {
  if (!item) return '';
  if (item.weight_kgs) return `${item.weight_kgs} kgs`;
  const lbs = item.weight || item.weight_lbs;
  if (lbs) return `${lbs} lbs`;
  return '';
}

export function formatLineItemDimensions(item) {
  if (!item) return '';
  if (item.length_cm || item.width_cm || item.height_cm) {
    return `${item.length_cm || 0} × ${item.width_cm || 0} × ${item.height_cm || 0} cm`;
  }
  const length = item.length || item.length_in;
  const width = item.width || item.width_in;
  const height = item.height || item.height_in;
  if (length || width || height) {
    return `${length || 0} × ${width || 0} × ${height || 0} in`;
  }
  return '';
}
